import { Subject } from 'rxjs';

export const showOperatorsType = ['Display Date', 'Submitted Date', 'Priority', 'Subject', 'DateAndTime'];

export enum GridActionType {
    changeObjectType
}

export enum GridEventType {
    apply,
    initFilterParams
}

export class AuditLogFilterConfig {
    actions$: Subject<{ type: GridActionType, payload?: any }>;
    events$: Subject<{ type: GridEventType, payload?: any }>;
    constructor() {
        this.events$ = new Subject();
        this.actions$ = new Subject();
    }
}
